import { useNavigate, useParams } from "react-router-dom"

import { CollectionSearchPanel } from "@components/panels/CollectionSearchPanel"

import { facets } from "@constants/facets"

import { DocumentSearchProvider } from "@plugins/providers/document/DocumentSearchProvider"

export function CollectionPage() {
    const { cId } = useParams()
    const navigate = useNavigate()

    const navigateTo404 = () => {
        navigate("/404")
    }

    if (!cId) {
        navigateTo404()
    }

    return (
        <DocumentSearchProvider facets={facets} collectionId={cId}>
            <CollectionSearchPanel />
        </DocumentSearchProvider>
    )
}
